var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star_hover_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".star_hover_svg__ds{fill:#979797}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "star_hover_svg__ds",
    d: "m387.39,175.15c-1.41-4.34-5.17-7.51-9.69-8.17l-104.99-15.26-46.95-95.14c-2.02-4.1-6.19-6.69-10.76-6.69s-8.74,2.59-10.76,6.69l-46.95,95.14-104.99,15.26c-4.52.66-8.28,3.82-9.69,8.17-1.41,4.34-.23,9.11,3.04,12.3l75.97,74.05-17.93,104.56c-.77,4.5,1.08,9.05,4.77,11.74,3.7,2.69,8.59,3.04,12.64.91l93.91-49.37,93.91,49.37c1.76.92,3.67,1.38,5.58,1.38,2.49,0,4.96-.77,7.05-2.29,3.7-2.68,5.55-7.23,4.77-11.74l-17.93-104.56,75.97-74.05c3.27-3.19,4.45-7.96,3.04-12.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHover);
export default __webpack_public_path__ + "static/media/star_hover.2266639e81ee4c87355aef6fb903b8e6.svg";
export { ForwardRef as ReactComponent };